<template>
    <article class="post-article-block block">
        <WpLink class="post-link" :url="data.link" :title="data.title">
            <WpImage size="medium_large" class="featured" v-if="data.featured_image" :image="data.featured_image" cover background />
            <div v-else class="featured dummy-image"><div class="img"></div></div>
            <div class="inner">
                <h3 class="titler margin-top">{{data.title}}</h3>
                <div v-if="subtitle" class="subtitle">
                    <p v-html="subtitle" />
                </div>
                <p class="excerpt-post" v-if="data.acf.page_excerpt">{{data.acf.page_excerpt.excerpt(124)}}</p>
                <div class="meta-footer">
                    <span class="cat-indi">{{categories}}</span>
                    <span class="ic" v-html="arrowIcon" />
                </div>
            </div>
        </WpLink>
    </article>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'
import { arrow } from '@/components/../icons';

import { mapGetters } from 'vuex'

export default {
    name: 'post-block', 
    props: ['data'],
    components:{
        WpImage,
        WpLink
    },
    computed:{
        ...mapGetters([
            'storedTaxonomy'
        ]),
        subtitle(){
            const subtitle = (this.data && this.data.acf && this.data.acf.subtitle) ? this.data.acf.subtitle : ''
            const pre = (this.data.type !== 'ambassadors') ? '- ' : '';
            return subtitle ? pre + subtitle : ''
        },
        arrowIcon(){
            return arrow('#00344D')
        },
        categories(){
            let cats = [];
            if(this.data.type === 'post' && this.data.categories && this.data.categories.length) cats = this.data.categories.map(ca=> ca.name)
            if(this.data.type === 'ambassadors' && this.data.acf && this.data.acf.category && this.data.acf.category.length) {
                cats = this.data.acf.category.map(ca=> {
                    const findCategory = this.storedTaxonomy('category_ambasador', ca);
                    if(findCategory && findCategory.name) return findCategory.name
                })  
            }
            
            // NICE TO DO: fix it as fn. instead of repeated code
            if(this.data.type === 'professions' && this.data.acf && this.data.acf.work_place ) {
                cats = this.data.acf.work_place.map(ca=> {
                    const findCategory = this.storedTaxonomy('work_place', ca);
                    if(findCategory && findCategory.name) return findCategory.name
                })
            }
            if(this.data.type === 'educations' && this.data.acf && this.data.acf.education_level ) {
                cats = this.data.acf.education_level.map(ca=> {
                    const findCategory = this.storedTaxonomy('education_level', ca);
                    if(findCategory && findCategory.name) return findCategory.name
                })
            }
            return cats.join(', ')
        }
    },
    mounted(){
    }

};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.post-article-block{
    .excerpt-post{
        @include fluid-type($smallResText, $wideResText, 12px, 14px);
    }
    .wp-image-vue.background div.image{
        border-top-left-radius: $blocksRadius;
        border-top-right-radius: $blocksRadius; 
    }
    .wp-image-vue.background div.image, .wp-image-vue{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
    .post-link{
        border-radius: $blocksRadius;
        background-color: #fff;
        display: block;
        text-decoration: none;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 0px 0 #3aa2c6;
        transition: box-shadow 0.2s ease-in-out;
        &:hover{
            box-shadow: 6px 6px 0 #3aa2c6;
        }
        .subtitle{
            margin-top: -5px;
            font-weight: bold;
            @include fluid-type($smallResText, $wideResText, 12px, 14px);
        }
        .titler{
            margin: 0;
            font-weight: bold;
            @include fluid-type($smallResText, $wideResText, 14px, 20px);
        }
        .inner{
            padding: 25px;
            flex: 1;
            flex-direction: column;
            justify-content: space-between;
            display: flex;
            @include mquery($tablet){
                padding: 15px;
            }
        }
        .meta-footer{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 25px;
            .ic{
                margin-left: 25px;
            }
            svg{
                transform: rotate(180deg)
            }
            @include fluid-type($smallResText, $wideResText, 12px, 14px);
            @include mquery($tablet){
                margin-top: 20px;
            }

        }
    }
    .dummy-image .img{
        border-radius: $radius;
        height: 0;
        background-color: #dedede;
        padding-bottom: 56.4%;
    }
}
</style>